var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.flag.subtype === 'flag')?[_vm._v(" "+_vm._s(_vm.flag.flag_category.name)+" ")]:[_vm._v(" "+_vm._s(_vm.flagSubtypes[_vm.flag.subtype])+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }